import React from 'react';
import PropTypes from 'prop-types';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import Block from '../../../block/Block';
import ExpandCollapseIcon from '../../../icons/expand-collapse/ExpandCollapseIcon';
import Accordion from '../../../accordion/Accordion';
import Translatable from '../../../translatable/Translatable';
import styles from './CmsAccordion.less';
export var CmsAccordion = function CmsAccordion(_ref) {
  var title = _ref.title,
      content = _ref.content,
      templateType = _ref.templateType,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen;
  return /*#__PURE__*/React.createElement(Block, {
    className: getClasses({
      styles: styles,
      classes: ['benefitsBlock']
    }),
    mb: "b"
  }, /*#__PURE__*/React.createElement(Accordion, {
    open: defaultOpen
  }, /*#__PURE__*/React.createElement(Accordion.Control, null, /*#__PURE__*/React.createElement(ExpandCollapseIcon, null), /*#__PURE__*/React.createElement(Block, {
    className: styles.titleWithIcon,
    pl: "xl",
    ml: "xxs",
    p: "b"
  }, title)), /*#__PURE__*/React.createElement(Accordion.Content, null, /*#__PURE__*/React.createElement(Block, {
    className: styles.titleWithIcon,
    pl: "xl",
    ml: "xxs",
    pr: "m",
    pb: "m"
  }, templateType === 'MARKETING' || templateType === 'NOTIFICATION' ? /*#__PURE__*/React.createElement("span", {
    className: "visuallyHidden"
  }, "Begin content") : /*#__PURE__*/React.createElement(Translatable, {
    className: "visuallyHidden",
    id: "global.beginContent"
  }), content, templateType === 'MARKETING' || templateType === 'NOTIFICATION' ? /*#__PURE__*/React.createElement("span", {
    className: "visuallyHidden"
  }, "End content") : /*#__PURE__*/React.createElement(Translatable, {
    className: "visuallyHidden",
    id: "global.endContent"
  })))));
};
CmsAccordion.propTypes = {
  title: PropTypes.node,
  content: PropTypes.node,
  defaultOpen: PropTypes.bool
};
export default CmsAccordion;